import React, { useState, useRef, useEffect } from 'react'
import { TextField } from '@material-ui/core'
import './styles.scss'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import PersonIcon from '@material-ui/icons/Person'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import Scrollchor from 'react-scrollchor'
import { DataGrid } from '@material-ui/data-grid'
import HowToVoteIcon from '@material-ui/icons/HowToVote'
import NumberFormat from 'react-number-format'
import ReactDataGrid from 'react-data-grid'
import RotateLeftIcon from '@material-ui/icons/RotateLeft'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import { PortraitPicture } from 'components/portraitPicture'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'

import districts from '../../data/districts.csv'
import communesDataOfs from '../../data/communes-data-ofs.csv'

const useStyles = makeStyles(theme => ({
  item: {
    cursor: 'pointer'
  },
  text: {
    fontFamily: 'TamediaUI'
  },
  arrowIcon: {
    width: '0.5em',
    height: '0.5em'
  }
}))

interface Props {
  municipalities: []
  municipality: {}
  candidates: []
  handleSelectCandidate: () => void
}

export const Candidates = ({
  municipalities,
  municipality,
  candidates,
  handleSelectCandidate
}: Props) => {
  const gotoCommuneInfos = useRef(null)
  const urlParams = new URLSearchParams(window.location.search)
  const isEmbed = urlParams.get('embed')
  const turn = +urlParams.get('turn')
  console.log(municipality)
  console.log(municipalities)
  console.log(candidates)
  console.log(turn)

  const [selectedTurn, setSelectedTurn] = useState(turn || 2)

  const [
    showRepresentativenessTables,
    setShowRepresentativenessTables
  ] = useState(false)

  const columns = [
    {
      field: 'fullName',
      headerName: 'Nom',
      description: 'This column has a value getter and is not sortable.',
      sortable: true,
      flex: 1,
      valueGetter: params =>
        `${params.getValue('nom') || ''} ${params.getValue('prénom') || ''}`
    },
    {
      field: 'âge',
      headerName: 'Age',
      flex: 1
    },
    {
      field: 'liste',
      headerName: 'Liste',
      flex: 1
    }
  ]

  // Get the selected municiaplity data from the ofs
  const selectedCommuneDataOfs = municipality
    ? communesDataOfs.find(c => +c.code === +municipality.code)
    : null

  // Constructs the political parties list of the selected municipality
  if (selectedCommuneDataOfs)
    selectedCommuneDataOfs.politique = [
      {
        parti: 'PS',
        pct: selectedCommuneDataOfs.PS
      },
      {
        parti: 'PDC',
        pct: selectedCommuneDataOfs.PDC
      },
      {
        parti: 'PLR',
        pct: selectedCommuneDataOfs.PLR
      },
      {
        parti: 'UDC',
        pct: selectedCommuneDataOfs.UDC
      },
      {
        parti: 'PEV/PCS',
        pct: selectedCommuneDataOfs['PEV/PCS']
      },
      {
        parti: "Vert'libéraux",
        pct: selectedCommuneDataOfs.PVL
      },
      {
        parti: 'PBD',
        pct: selectedCommuneDataOfs.PBD
      },
      {
        parti: 'PST/Sol.',
        pct: selectedCommuneDataOfs['PST/Sol.']
      },
      {
        parti: 'Les Verts',
        pct: selectedCommuneDataOfs.PES
      },
      {
        parti: 'Petits partis de droite',
        pct: selectedCommuneDataOfs['Petits partis de droite']
      }
    ].sort((a, b) => b.pct - a.pct)

  const selectedCommuneDataVqh = municipality
    ? municipalities.find(c => +c.id === +municipality.code)
    : null

  console.log(selectedCommuneDataOfs)
  console.log(selectedCommuneDataVqh)

  const count = selectedCommuneDataOfs
    ? {
        ages: [
          {
            label: '18-30 ans',
            count: candidates.filter(c => c['âge'] >= 18 && c['âge'] < 30)
              .length,
            municipalityPct: selectedCommuneDataOfs['ages pct 18-30']
          },
          {
            label: '30-45 ans',
            count: candidates.filter(c => c['âge'] >= 30 && c['âge'] < 45)
              .length,
            municipalityPct: selectedCommuneDataOfs['ages pct 30-45']
          },
          {
            label: '45-60 ans',
            count: candidates.filter(c => c['âge'] >= 45 && c['âge'] < 60)
              .length,
            municipalityPct: selectedCommuneDataOfs['ages pct 45-60']
          },
          {
            label: 'Plus de 60 ans',
            count: candidates.filter(c => c['âge'] >= 60).length,
            municipalityPct: selectedCommuneDataOfs['ages pct >60']
          }
        ],
        femmes: [
          {
            label: 'Femmes',
            count: candidates.filter(c => c.genre === 'Femme').length,
            municipalityPct: 50
          },
          {
            label: 'Hommes',
            count: candidates.filter(c => c.genre === 'Homme').length,
            municipalityPct: 50
          }
        ],
        secteursPro: [
          {
            label: 'Primaire',
            count: candidates.filter(c => c.secteur === 'Primaire').length,
            municipalityPct:
              (+selectedCommuneDataOfs['tot - Secteur primaire'] /
                (+selectedCommuneDataOfs['tot - Secteur primaire'] +
                  +selectedCommuneDataOfs['tot - Secteur secondaire'] +
                  +selectedCommuneDataOfs['tot - Secteur tertiaire'])) *
              100
          },
          {
            label: 'Secondaire',
            count: candidates.filter(c => c.secteur === 'Secondaire').length,
            municipalityPct:
              (+selectedCommuneDataOfs['tot - Secteur secondaire'] /
                (+selectedCommuneDataOfs['tot - Secteur primaire'] +
                  +selectedCommuneDataOfs['tot - Secteur secondaire'] +
                  +selectedCommuneDataOfs['tot - Secteur tertiaire'])) *
              100
          },
          {
            label: 'Tertiaire',
            count: candidates.filter(c => c.secteur === 'Tertiaire').length,
            municipalityPct:
              (+selectedCommuneDataOfs['tot - Secteur tertiaire'] /
                (+selectedCommuneDataOfs['tot - Secteur primaire'] +
                  +selectedCommuneDataOfs['tot - Secteur secondaire'] +
                  +selectedCommuneDataOfs['tot - Secteur tertiaire'])) *
              100
          }
        ]
      }
    : null

  const electedCandidates = candidates
    .filter(
      c =>
        c['élu au premier tour'] === 'TRUE' ||
        c['élu tacitement'] === 'TRUE' ||
        c['élu deuxieme tour'] === 'TRUE'
    )
    .sort(
      (a, b) =>
        b['nb voix premier tour'] - a['nb voix premier tour'] ||
        a.nom.localeCompare(b.nom, 'fr', { ignorePunctuation: true })
    )

  const electedFirstRoundCandidates = candidates
    .filter(
      c =>
        c['élu au premier tour'] === 'TRUE' ||
        c['élu tacitement 9 mars'] === 'TRUE'
    )
    .sort(
      (a, b) =>
        b['nb voix premier tour'] - a['nb voix premier tour'] ||
        a.nom.localeCompare(b.nom, 'fr', { ignorePunctuation: true })
    )

  const electedSecondRoundCandidates = candidates
    .filter(c => c['élu au premier tour'] === 'FALSE')
    .filter(
      c =>
        c['élu deuxieme tour'] === 'TRUE' || c['élu 2e tour 28 mars'] === 'TRUE'
    )
    .sort(
      (a, b) =>
        b['nb voix 2e tour 28 mars'] - a['nb voix 2e tour 28 mars'] ||
        b['nb voix deuxième tour'] - a['nb voix deuxième tour'] ||
        a.nom.localeCompare(b.nom, 'fr', { ignorePunctuation: true })
    )

  console.log(electedCandidates)
  const nonElectedCandidates = candidates
    .filter(
      c =>
        c['élu au premier tour'] !== 'TRUE' &&
        c['élu tacitement'] !== 'TRUE' &&
        c['élu deuxieme tour'] !== 'TRUE' &&
        c['élu tacitement 9 mars'] !== 'TRUE'
    )
    .sort(
      (a, b) =>
        b['nb voix premier tour'] - a['nb voix premier tour'] ||
        a.nom.localeCompare(b.nom, 'fr', { ignorePunctuation: true })
    )

  const nonElectedFirstRoundCandidates = candidates
    .filter(
      c =>
        c['élu au premier tour'] !== 'TRUE' &&
        c['élu tacitement 9 mars'] !== 'TRUE'
    )
    .sort(
      (a, b) =>
        b['nb voix premier tour'] - a['nb voix premier tour'] ||
        a.nom.localeCompare(b.nom, 'fr', { ignorePunctuation: true })
    )

  const nonElectedSecondRoundCandidates = candidates
    .filter(
      c =>
        c['candidat 2 tour 28 mars'] === 'TRUE' ||
        c['nb voix deuxième tour'] !== ''
    )
    .filter(
      c =>
        c['élu deuxieme tour'] === 'FALSE' &&
        c['élu 2e tour 28 mars'] === 'FALSE'
    )
    .sort(
      (a, b) =>
        b['nb voix 2e tour 28 mars'] - a['nb voix 2e tour 28 mars'] ||
        b['nb voix deuxième tour'] - a['nb voix deuxième tour'] ||
        a.nom.localeCompare(b.nom, 'fr', { ignorePunctuation: true })
    )

  const voteCount = candidates.reduce(
    (a, b) =>
      a + (b['nb voix premier tour'] !== '' ? +b['nb voix premier tour'] : 0),
    0
  )

  const voteCountSecondRound = candidates.reduce(
    (a, b) =>
      a +
      (b['nb voix deuxième tour'] !== '' ? +b['nb voix deuxième tour'] : 0) +
      (b['nb voix 2e tour 28 mars'] !== '' ? +b['nb voix 2e tour 28 mars'] : 0),
    0
  )

  console.log(voteCountSecondRound)

  useEffect(() => {
    setSelectedTurn(turn || 1)
  }, [municipality])

  return (
    <>
      {selectedCommuneDataOfs && selectedCommuneDataVqh && (
        <div
          className='ui vertical grey segment'
          id='commune-infos'
          style={{
            backgroundColor: isEmbed ? '#ffffff' : '#3237751a'
          }}
        >
          <div className={isEmbed ? '' : 'ui text container'}>
            <div className='commune-portrait'>
              {selectedCommuneDataVqh['tient des élections'] === 'TRUE' ? (
                <div className='ui vertical segment candidates-list'>
                  <div
                    style={{
                      marginTop: '2em',
                      position: 'relative'
                    }}
                  >
                    {/* <div className='panel-title'>Les candidats</div> */}

                    <div className='candidates-list-container'>
                      <div className='results-info'>
                        <h4>{selectedCommuneDataOfs.nom}</h4>
                        {electedCandidates.length < 0 ? (
                          <>
                            <div>Le nouveau conseil municipal</div>
                            <div className='tabular-block'>
                              {electedCandidates.map(candidate => (
                                <CandidateItem
                                  maj=''
                                  votes=''
                                  key={candidate.id}
                                  candidate={candidate}
                                  handleSelect={handleSelectCandidate}
                                  totVoteCount={voteCount}
                                />
                              ))}
                              {[
                                ...new Array(
                                  +selectedCommuneDataVqh[
                                    'conseillers municipaux'
                                  ] - electedCandidates.length
                                )
                              ].map((candidate, i) => (
                                <div
                                  key={`candidates-placeholder-${i}`}
                                  className='candidate-item'
                                >
                                  <div className='candidate-portrait'>
                                    <PortraitPicture
                                      id={null}
                                      genre={
                                        ['Homme', 'Femme'][
                                          Math.ceil(0.5 - Math.random())
                                        ]
                                      }
                                    />
                                  </div>
                                  <div className='candidate-infos'>
                                    <div className='second'>
                                      <div className='liste' />
                                      <svg
                                        style={{
                                          margin: 'auto',
                                          background: '#fff',
                                          display: 'inline-block'
                                        }}
                                        width='18px'
                                        height='18px'
                                        viewBox='0 0 100 100'
                                        preserveAspectRatio='xMidYMid'
                                      >
                                        <path
                                          fill='none'
                                          d='M50 32.5A17.5 17.5 0 0 1 50 67.5A17.5 17.5 0 0 1 50 32.5'
                                          stroke='#d8d8d8'
                                          strokeWidth='35'
                                        >
                                          <animate
                                            attributeName='stroke-dasharray'
                                            repeatCount='indefinite'
                                            dur='5'
                                            values='0 0 0 110;0 0 110 110;0 110 110 110'
                                            keyTimes='0;0.5;1'
                                            keySplines='0.5 0 0.5 1;0.5 0 0.5 1'
                                            calcMode='spline'
                                          />
                                          <animate
                                            attributeName='stroke'
                                            values='#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8'
                                            keyTimes='0;0.25;0.5;0.75;1'
                                            dur='20s'
                                            calcMode='discrete'
                                            repeatCount='indefinite'
                                          />
                                        </path>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <div>
                            Sièges à pourvoir:{' '}
                            <b>
                              {selectedCommuneDataVqh['conseillers municipaux']}
                            </b>
                          </div>
                        )}
                      </div>

                      <div className='tabular-block'>
                        <div className='tabular menu'>
                          <div
                            onClick={() => {
                              setSelectedTurn(1)
                            }}
                            className={`item${
                              selectedTurn === 1 ? ' active' : ''
                            }`}
                          >
                            Premier tour
                          </div>
                          {electedFirstRoundCandidates.length !==
                            +selectedCommuneDataVqh[
                              'conseillers municipaux'
                            ] && (
                            <div
                              onClick={() => {
                                setSelectedTurn(2)
                              }}
                              className={`item${
                                selectedTurn === 2 ? ' active' : ''
                              }`}
                            >
                              Deuxième tour
                            </div>
                          )}
                        </div>
                        {(selectedTurn === 1 ||
                          electedFirstRoundCandidates.length ===
                            +selectedCommuneDataVqh[
                              'conseillers municipaux'
                            ]) && (
                          <div className='tab segment'>
                            {candidates.reduce(
                              (a, b) => a + b['nb voix premier tour'],
                              ''
                            ) === '' ? (
                              <div>
                                Nous n'avons pas encore de résultat pour cette
                                commune
                              </div>
                            ) : (
                              selectedCommuneDataVqh[
                                'taux de participation 1er tour'
                              ] === '' && (
                                <div>
                                  Nous n'avons pas encore de résultat définitif
                                  pour cette commune
                                </div>
                              )
                            )}
                            {selectedCommuneDataVqh[
                              'taux de participation 1er tour'
                            ] !== '' && (
                              <div>
                                Résultat final{' '}
                                <i className='ui circle check icon' />
                              </div>
                            )}
                            {selectedCommuneDataVqh[
                              'taux de participation 1er tour'
                            ] !== '' && (
                              <div>
                                Taux de participation:{' '}
                                <b>
                                  {
                                    selectedCommuneDataVqh[
                                      'taux de participation 1er tour'
                                    ]
                                  }
                                </b>
                              </div>
                            )}
                            {selectedCommuneDataVqh['majorité absolue'] !==
                              '' && (
                              <div style={{ marginBottom: '0.45em' }}>
                                Majorité absolue:{' '}
                                <b>
                                  {selectedCommuneDataVqh['majorité absolue']}
                                </b>
                              </div>
                            )}
                            {electedFirstRoundCandidates.length > 0 && (
                              <div className='result-group elected-group'>
                                <div className='results-head'>
                                  <div>
                                    {electedCandidates.length > 1
                                      ? 'Élus'
                                      : 'Élu'}
                                  </div>
                                  <div>Voix</div>
                                </div>
                                <div>
                                  {electedFirstRoundCandidates.map(
                                    candidate => (
                                      <CandidateItem
                                        maj={
                                          +selectedCommuneDataVqh[
                                            'majorité absolue'
                                          ].replace(/\D+/g, '')
                                        }
                                        votes={
                                          candidate['nb voix premier tour']
                                        }
                                        key={candidate.id}
                                        candidate={candidate}
                                        handleSelect={handleSelectCandidate}
                                        totVoteCount={voteCount}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                            {nonElectedFirstRoundCandidates.length > 0 && (
                              <div className='result-group non-elected-group'>
                                <div className='results-head'>
                                  <div>
                                    {nonElectedFirstRoundCandidates.length > 1
                                      ? 'Non élus'
                                      : 'Non élu'}
                                  </div>
                                  <div>Voix</div>
                                </div>

                                <div>
                                  {nonElectedFirstRoundCandidates.map(
                                    candidate => (
                                      <CandidateItem
                                        maj={
                                          +selectedCommuneDataVqh[
                                            'majorité absolue'
                                          ].replace(/\D+/g, '')
                                        }
                                        key={candidate.id}
                                        votes={
                                          candidate['nb voix premier tour']
                                        }
                                        candidate={candidate}
                                        handleSelect={handleSelectCandidate}
                                        totVoteCount={voteCount}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {selectedTurn === 2 &&
                          electedFirstRoundCandidates.length !==
                            +selectedCommuneDataVqh[
                              'conseillers municipaux'
                            ] && (
                            <div className='tab segment'>
                              {candidates.reduce(
                                (a, b) =>
                                  a +
                                  b['nb voix deuxième tour'] +
                                  b['nb voix 2e tour 28 mars'],
                                ''
                              ) === '' ? (
                                <div>
                                  Nous n'avons pas encore de résultat pour cette
                                  commune
                                </div>
                              ) : (
                                selectedCommuneDataVqh[
                                  'taux de participation 2e tour'
                                ] === '' && (
                                  <div>
                                    Nous n'avons pas encore de résultat
                                    définitif pour cette commune
                                  </div>
                                )
                              )}
                              {selectedCommuneDataVqh[
                                'taux de participation 2e tour'
                              ] !== '' && (
                                <div>
                                  Résultat final{' '}
                                  <i className='ui circle check icon' />
                                </div>
                              )}

                              {selectedCommuneDataVqh[
                                'taux de participation 2e tour'
                              ] !== '' && (
                                <div>
                                  Taux de participation:{' '}
                                  <b>
                                    {
                                      selectedCommuneDataVqh[
                                        'taux de participation 2e tour'
                                      ]
                                    }
                                  </b>
                                </div>
                              )}

                              {electedSecondRoundCandidates.length > 0 && (
                                <div className='result-group elected-group'>
                                  <div className='results-head'>
                                    <div>
                                      {electedSecondRoundCandidates.length > 1
                                        ? 'Élus'
                                        : 'Élu'}
                                    </div>
                                    <div>Voix</div>
                                  </div>
                                  <div>
                                    {electedSecondRoundCandidates.map(
                                      candidate => (
                                        <CandidateItem
                                          maj=''
                                          votes={
                                            candidate[
                                              'nb voix deuxième tour'
                                            ] === '' &&
                                            candidate[
                                              'nb voix 2e tour 28 mars'
                                            ] === ''
                                              ? ''
                                              : +candidate[
                                                  'nb voix deuxième tour'
                                                ] +
                                                +candidate[
                                                  'nb voix 2e tour 28 mars'
                                                ]
                                          }
                                          key={candidate.id}
                                          candidate={candidate}
                                          handleSelect={handleSelectCandidate}
                                          totVoteCount={voteCountSecondRound}
                                        />
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                              {nonElectedSecondRoundCandidates.length > 0 && (
                                <div className='result-group non-elected-group'>
                                  <div className='results-head'>
                                    <div>
                                      {nonElectedSecondRoundCandidates.length >
                                      1
                                        ? 'Non élus'
                                        : 'Non élu'}
                                    </div>
                                    <div>Voix</div>
                                  </div>

                                  <div>
                                    {nonElectedSecondRoundCandidates.map(
                                      candidate => (
                                        <CandidateItem
                                          maj=''
                                          key={candidate.id}
                                          votes={
                                            candidate[
                                              'nb voix deuxième tour'
                                            ] === '' &&
                                            candidate[
                                              'nb voix 2e tour 28 mars'
                                            ] === ''
                                              ? ''
                                              : +candidate[
                                                  'nb voix deuxième tour'
                                                ] +
                                                +candidate[
                                                  'nb voix 2e tour 28 mars'
                                                ]
                                          }
                                          candidate={candidate}
                                          handleSelect={handleSelectCandidate}
                                          totVoteCount={voteCountSecondRound}
                                        />
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='ui blue vertical segment candidates-list'>
                  <div
                    className='ui center aligned text container'
                    style={{
                      position: 'relative',
                      color: '#ffffff',
                      fontFamily: 'TamediaUI'
                    }}
                  >
                    Cette commune ne tient pas d'élection.
                  </div>
                </div>
              )}
              <div />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const PartisTable = ({ data }) => {
  const [showAll, setShowAll] = useState(false)

  return (
    <>
      <table className='bar-chart-list'>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '70%' }} />
        </colgroup>
        <tbody>
          {data.slice(0, showAll ? data.length : 3).map((p, i) => (
            <tr key={i}>
              <td className='chart-bar-label'>
                <b>{p.parti}</b>
              </td>
              <td>
                <div className='chart-value'>{p.pct}%</div>
                <div className='chart-bar-container'>
                  <div className='chart-bar' style={{ width: p.pct + '%' }} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='ui center aligned'>
        <div
          style={{ textAlign: 'center' }}
          className='pseudo-link'
          onClick={() => {
            setShowAll(!showAll)
          }}
        >
          <span>{showAll ? 'Réduire la liste' : 'Voir toute la liste'}</span>
          {/* <i className={`ui icon chevron ${showAll ? 'up' : 'down'}`} /> */}
        </div>
      </div>
    </>
  )
}

const RepresentativenessTable = ({
  open,
  title,
  data,
  municipalityCandidatesCount
}) => {
  const [showTable, setShowTable] = useState(open)
  const representativenessMean = Math.round(
    100 -
      data.reduce(
        (a, b) =>
          a +
          Math.abs(
            (b.count / municipalityCandidatesCount) * 100 - b.municipalityPct
          ),
        0
      ) /
        data.length
  )

  useEffect(() => {
    setShowTable(open)
  }, [open])

  const getRepresentativenessMeanWord = val => {
    const words = [
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'basse',
      'basse',
      'basse',
      'moyenne',
      'moyenne',
      'bonne',
      'bonne',
      'excellente',
      'excellente'
    ]
    return words[Math.round((val / 100) * 20)]
  }

  return (
    <div className='rep-table-container'>
      <div className='title' dangerouslySetInnerHTML={{ __html: title }} />
      <div>
        <div className='rep-circle-container'>
          <div className='left'>
            <RepresentativenessCircle value={representativenessMean} />
            <div className='rep-circle-text'>{representativenessMean}%</div>
          </div>
          <div className='right'>
            <div className='grey small text'>
              Représentativité{' '}
              <b>{getRepresentativenessMeanWord(representativenessMean)}</b>
            </div>
          </div>
        </div>
      </div>
      {showTable && (
        <div className='rep-table'>
          <div className='legend'>
            <div className='legend-item'>
              <div className='legend-block-commune' />
              Commune
            </div>
            <div className='legend-item'>
              <div className='legend-block-candidats' />
              Candidats
            </div>
          </div>
          {data.map((d, i) => (
            <div key={i} className='rep-chart-item'>
              <div className='rep-chart-label'>
                <b>{d.label}</b>
              </div>
              <div>
                <RepresentativenessB
                  municipalityCandidatesCount={municipalityCandidatesCount}
                  candidatesCount={d.count}
                  municipalityPct={d.municipalityPct}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {/* <div
        style={{ textAlign: 'center' }}
        className='pseudo-link'
        onClick={() => {
          setShowTable(!showTable)
        }}
      >
        <span>{showTable ? 'Masquer' : 'Afficher'} le détail</span>
      </div> */}
    </div>
  )
}

const RepresentativenessB = ({
  municipalityCandidatesCount,
  candidatesCount,
  municipalityPct
}) => {
  const candidatesPct = (candidatesCount / municipalityCandidatesCount) * 100
  const candidatesDiff = Math.abs(
    Math.round(
      candidatesCount - (municipalityCandidatesCount * municipalityPct) / 100
    )
  )

  return (
    <div className='rep-chart-b'>
      <div className='rep-chart-bars'>
        <div className='line line-25' />
        <div className='line line-50' />
        <div className='line line-75' />

        <div className='rep-bar-container'>
          {/* <div className='rep-bar-value'>{Math.round(municipalityPct)}%</div> */}
          <div className='rep-bar-b-full'>
            <div
              className='rep-bar-b municipality'
              style={{
                width:
                  (Math.abs(municipalityPct) > 0
                    ? Math.abs(municipalityPct)
                    : 1) + '%'
              }}
            />
          </div>
        </div>
        <div className='rep-bar-container'>
          {/* <div className='rep-bar-value'>{Math.round(candidatesPct)}%</div> */}
          <div className='rep-bar-b-full'>
            <div
              className='rep-bar-b candidates'
              style={{
                width:
                  (Math.abs(candidatesPct) > 0 ? Math.abs(candidatesPct) : 1) +
                  '%'
              }}
            />
          </div>
        </div>
      </div>
      <div
        className={`rep-chart-diff ${
          candidatesPct - municipalityPct > 0
            ? 'more'
            : candidatesPct - municipalityPct < 0
            ? 'less'
            : ''
        }`}
      >
        {candidatesPct - municipalityPct > 0 ? '+' : ''}
        {Math.round(candidatesPct - municipalityPct)}
        <small>%</small>
      </div>

      {candidatesDiff > 0 && (
        <div className='rep-chart-infos'>
          <div className='text grey small'>
            {candidatesPct - municipalityPct > 0
              ? `${candidatesDiff} candidat${
                  candidatesDiff > 1 ? 's' : ''
                } de trop`
              : `Il manque ${candidatesDiff} candidat${
                  candidatesDiff > 1 ? 's' : ''
                }`}
          </div>
        </div>
      )}
    </div>
  )
}

const RepresentativenessCircle = ({ value }) => {
  return (
    <div className='rep-circle'>
      <div
        className='rep-circle-value'
        style={{ marginLeft: ((100 - value) * 100) / 100 + 'px' }}
      />
    </div>
  )
}

const CandidateItem = ({
  candidate,
  handleSelect,
  totVoteCount,
  maj,
  votes
}) => {
  return (
    <div
      key={candidate.id}
      className='candidate-item'
      onClick={() => {
        handleSelect(candidate)
      }}
    >
      <div className='candidate-portrait'>
        <PortraitPicture id={candidate.id} genre={candidate.genre} />
      </div>
      <div className='candidate-infos'>
        <div>
          <b>
            {candidate['prénom']} {candidate.nom}
            {candidate.sortant ? (
              <>
                {' '}
                <i>(sortant{candidate.genre === 'Femme' ? 'e' : ''})</i>
              </>
            ) : (
              ''
            )}
          </b>
        </div>
        {/*
          {candidate['âge'] !== '' && <div>{candidate['âge']} ans</div>}
          <div>{candidate.profession}</div>
          */}
        <div className='second'>
          <div className='liste'>{candidate.liste}</div>
          {votes !== '' ? (
            <>
              <div className='bar-container'>
                {maj !== '' && (
                  <div
                    className='maj'
                    style={{
                      left: `${(maj / totVoteCount) * 100}%`
                    }}
                  />
                )}
                <div
                  className='bar'
                  style={{
                    width: `${(+votes / totVoteCount) * 100}%`
                  }}
                />
              </div>
              {votes && (
                <div className='vval'>
                  <NumberFormat
                    value={votes}
                    displayType='text'
                    thousandSeparator='’'
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <div className='bar-container' />
              <svg
                style={{
                  margin: 'auto',
                  background: '#fff',
                  display: 'inline-block'
                }}
                width='18px'
                height='18px'
                viewBox='0 0 100 100'
                preserveAspectRatio='xMidYMid'
              >
                <path
                  fill='none'
                  d='M50 32.5A17.5 17.5 0 0 1 50 67.5A17.5 17.5 0 0 1 50 32.5'
                  stroke='#d8d8d8'
                  strokeWidth='35'
                >
                  <animate
                    attributeName='stroke-dasharray'
                    repeatCount='indefinite'
                    dur='5'
                    values='0 0 0 110;0 0 110 110;0 110 110 110'
                    keyTimes='0;0.5;1'
                    keySplines='0.5 0 0.5 1;0.5 0 0.5 1'
                    calcMode='spline'
                  />
                  <animate
                    attributeName='stroke'
                    values='#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8'
                    keyTimes='0;0.25;0.5;0.75;1'
                    dur='20s'
                    calcMode='discrete'
                    repeatCount='indefinite'
                  />
                </path>
              </svg>
            </>
          )}
        </div>
        {candidate['syndic élu 7 mars'] === 'TRUE' && (
          <div>
            Élu{candidate.genre === 'Femme' ? 'e' : ''}{' '}
            {candidate.genre === 'Femme' ? 'syndique' : 'syndic'} le 7 mars
          </div>
        )}
        {candidate['syndic tacite RP et MAJ'] === 'TRUE' && (
          <div>
            Élu{candidate.genre === 'Femme' ? 'e' : ''}{' '}
            {candidate.genre === 'Femme' ? 'syndique' : 'syndic'} tacitement le
            6 avril
          </div>
        )}
        {candidate['candidat syndic 1er tour'] === 'TRUE' && (
          <div>
            {candidate.genre === 'Femme' ? 'Candidate' : 'Candidat'} au 1er tour
            de l'élection à la syndicature
          </div>
        )}
      </div>
    </div>
  )
}
